<pages-container
  [title]="'main.parishOrganization'"
  [icon]="'account_balance'">
  <div back-button>
    <button class="back-button" mat-icon-button (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
  <div buttons>
    <button mat-raised-button
            (click)="back()"
            class="mat-white-bg">
      <span>{{ 'main.cancel' | translate }}</span>
    </button>
    @if (id()) {
      <button mat-raised-button
              class="mat-white-bg"
              (click)="delete()">
        <span>{{ 'main.delete' | translate }}</span>
      </button>
    }
    <button mat-raised-button
            class="mat-white-bg"
            [disabled]="!parishOrgForm().valid()"
            (click)="save()">
      <span>
        @if (!id()) {
          {{ 'main.save' | translate }}
        } @else {
          {{ 'main.update' | translate }}
        }
      </span>
    </button>
  </div>

  <div main-content>
    <mat-accordion class="parish-org-form-container" multi="true">
      <mat-expansion-panel expanded="true">
        <div class="form-container">
          <mat-form-field class="full-width">
            <mat-label>{{ 'parishOrganization.name' | translate }}</mat-label>
            <input matInput [formField]="parishOrgForm.name">
            @if (parishOrgForm.name().invalid() && parishOrgForm.name().touched()) {
              <mat-error>
                @for (error of parishOrgForm.name().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="half-width">
            <mat-label>{{ 'canton.country' | translate }}</mat-label>
            <mat-select [formField]="parishOrgForm.countryId">
              @for (country of countries(); track country.id) {
                <mat-option [value]="country.id">
                  {{ country.name }}
                </mat-option>
              }
            </mat-select>
            @if (parishOrgForm.countryId().invalid() && parishOrgForm.countryId().touched()) {
              <mat-error>
                @for (error of parishOrgForm.countryId().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="half-width">
            <mat-label>{{ 'main.canton' | translate }}</mat-label>
            <mat-select [formField]="parishOrgForm.cityId">
              @for (city of cities(); track city.id) {
                <mat-option [value]="city.id">
                  {{ city.name }}
                </mat-option>
              }
            </mat-select>
            @if (parishOrgForm.cityId().invalid() && parishOrgForm.cityId().touched()) {
              <mat-error>
                @for (error of parishOrgForm.cityId().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="third-width">
            <mat-label>{{ 'parishOrganization.firstName' | translate }} ({{ 'parishOrganization.responsible' | translate }})</mat-label>
            <input matInput [formField]="parishOrgForm.responsible_first_name">
            @if (parishOrgForm.responsible_first_name().invalid() && parishOrgForm.responsible_first_name().touched()) {
              <mat-error>
                @for (error of parishOrgForm.responsible_first_name().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="third-width">
            <mat-label>{{ 'parishOrganization.lastName' | translate }} ({{ 'parishOrganization.responsible' | translate }})</mat-label>
            <input matInput [formField]="parishOrgForm.responsible_last_name">
            @if (parishOrgForm.responsible_last_name().invalid() && parishOrgForm.responsible_last_name().touched()) {
              <mat-error>
                @for (error of parishOrgForm.responsible_last_name().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="third-width">
            <mat-label>{{ 'parishOrganization.email' | translate }} ({{ 'parishOrganization.responsible' | translate }})</mat-label>
            <input matInput type="email" [formField]="parishOrgForm.responsible_email">
            @if (parishOrgForm.responsible_email().invalid() && parishOrgForm.responsible_email().touched()) {
              <mat-error>
                @for (error of parishOrgForm.responsible_email().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="third-width">
            <mat-label>{{ 'parishOrganization.firstName' | translate }} ({{ 'parishOrganization.president' | translate }})</mat-label>
            <input matInput [formField]="parishOrgForm.president_first_name">
            @if (parishOrgForm.president_first_name().invalid() && parishOrgForm.president_first_name().touched()) {
              <mat-error>
                @for (error of parishOrgForm.president_first_name().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="third-width">
            <mat-label>{{ 'parishOrganization.lastName' | translate }} ({{ 'parishOrganization.president' | translate }})</mat-label>
            <input matInput [formField]="parishOrgForm.president_last_name">
            @if (parishOrgForm.president_last_name().invalid() && parishOrgForm.president_last_name().touched()) {
              <mat-error>
                @for (error of parishOrgForm.president_last_name().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="third-width">
            <mat-label>{{ 'parishOrganization.email' | translate }} ({{ 'parishOrganization.president' | translate }})</mat-label>
            <input matInput type="email" [formField]="parishOrgForm.president_email">
            @if (parishOrgForm.president_email().invalid() && parishOrgForm.president_email().touched()) {
              <mat-error>
                @for (error of parishOrgForm.president_email().errors(); track error) {
                  {{ error.message | translate }}
                }
              </mat-error>
            }
          </mat-form-field>

          <mat-checkbox [formField]="parishOrgForm.status" class="full-width">
            {{ 'parishOrganization.status' | translate }}
          </mat-checkbox>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</pages-container>
